import {PRIMITIVE} from "core/metamodel/metaConstant";

export type OBJECTMAP<T> = {[key: string]: T};

export enum CODEBLOCK {
  SHIPMENT_EMPLOYEE_SMS_TO_ADDRESS = "SHIPMENT_EMPLOYEE_SMS_TO_ADDRESS"
}

export enum CODEBLOCKLOCATION {
  TO_ADDRESS = "TO_ADDRESS"
}


export enum SEVERITY {
  INFO = "INFO",
  WARNING = "WARNING",
  ERROR = "ERROR",
  NOOP = "NOOP",
}


export interface ValidationMessage {
  propertyPath?: string;
  message?: string;
  severity?: SEVERITY;
  dberror?: string;
  errorCode?: string;
  params?: any[];
}



export interface Tuple<V1, V2> {
  value1: V1;
  value2: V2;
}

export interface SelectableHolder<V> {
  value: V;
  selected: boolean;
}

export interface ValidEntityIntf {
  validFrom?: string|Date;
  validTo?: string|Date;
}

export type TRequestParams = {[key: string]: PRIMITIVE};



// WEBPACK FOOTER //
// ./src/core/common/domain/commonDomain.ts